import { Flex } from 'antd';
import React from 'react';

import ConversationListItem from './ConversationListItem';

function ConversationListFlat({ conversations, selectedConversation, onSelectConversation }) {
  return (
    <Flex vertical>
      {conversations.map((conversation) => (
        <ConversationListItem
          key={conversation.id}
          conversation={conversation}
          isSelected={selectedConversation === conversation.id}
          onSelect={onSelectConversation}
        />
      ))}
    </Flex>
  );
}

export default ConversationListFlat;
